var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
import { jsx as _jsx } from "react/jsx-runtime";
import "../css/global.scss";
import { createRoot } from "react-dom/client";
import { FunnalbackListingBlock } from "./component";
import { FunnalbackTabListingBlock } from "./componentTab";
import dataConfig from "../data/data.json";
const FALLBACK_BASE = (_c = (_b = (_a = dataConfig === null || dataConfig === void 0 ? void 0 : dataConfig.funnalback) === null || _a === void 0 ? void 0 : _a.default) === null || _b === void 0 ? void 0 : _b.url) !== null && _c !== void 0 ? _c : "";
const FALLBACK_PARAMS = (_g = ((_f = (_e = (_d = dataConfig === null || dataConfig === void 0 ? void 0 : dataConfig.funnalback) === null || _d === void 0 ? void 0 : _d.default) === null || _e === void 0 ? void 0 : _e.params) !== null && _f !== void 0 ? _f : [])) !== null && _g !== void 0 ? _g : {};
const FALLBACK_TAB = (_k = (_j = (_h = dataConfig === null || dataConfig === void 0 ? void 0 : dataConfig.funnalback) === null || _h === void 0 ? void 0 : _h.default) === null || _j === void 0 ? void 0 : _j.tab) !== null && _k !== void 0 ? _k : false;
const FALLBACK_SEEALL = (_m = (_l = dataConfig === null || dataConfig === void 0 ? void 0 : dataConfig.pages) === null || _l === void 0 ? void 0 : _l.seeAllUrl) !== null && _m !== void 0 ? _m : "/all-news";
function parseParamsAttr(raw) {
    if (!raw || raw === "DEFAULT_PARAMS")
        return Object.assign({}, FALLBACK_PARAMS);
    // Try JSON first (e.g., '{"collection":"...","profile":"...","query":"..."}')
    try {
        const obj = JSON.parse(raw);
        if (obj && typeof obj === "object")
            return obj;
    }
    catch (_a) {
        // Not JSON — try querystring (e.g., 'collection=...&profile=...&query=!showall')
        const out = {};
        new URLSearchParams(raw).forEach((v, k) => (out[k] = v));
        if (Object.keys(out).length)
            return out;
    }
    // Fallback if malformed
    return Object.assign({}, FALLBACK_PARAMS);
}
function pickBase(raw) {
    if (!raw || raw === "BASE")
        return FALLBACK_BASE;
    return raw;
}
document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll('[data-module="FunnalbackListingBlock"]')
        .forEach((mount) => {
        var _a, _b, _c, _d, _e, _f;
        // Support either data-* or plain attrs
        const urlAttr = (_a = mount.getAttribute("data-url")) !== null && _a !== void 0 ? _a : mount.getAttribute("url");
        const tabAttr = (_c = (_b = mount.getAttribute("data-tab")) !== null && _b !== void 0 ? _b : mount.getAttribute("tab")) !== null && _c !== void 0 ? _c : FALLBACK_TAB;
        const tab = String(tabAttr).toLowerCase() === "true";
        const seeAll = (_e = (_d = mount.getAttribute("data-seeall")) !== null && _d !== void 0 ? _d : mount.getAttribute("seeall")) !== null && _e !== void 0 ? _e : FALLBACK_SEEALL;
        const paramsAttr = (_f = mount.getAttribute("data-params")) !== null && _f !== void 0 ? _f : mount.getAttribute("params");
        const numRanks = (() => {
            var _a;
            const raw = (_a = mount.getAttribute("data-num")) !== null && _a !== void 0 ? _a : mount.getAttribute("num");
            const n = raw != null ? Number.parseInt(raw, 10) : NaN;
            return Number.isFinite(n) ? n : 10;
        })();
        const base = pickBase(urlAttr);
        const params = parseParamsAttr(paramsAttr);
        createRoot(mount).render(tab == true
            ? _jsx(FunnalbackTabListingBlock, { initialBase: base, initialParams: params, initialSeeAll: seeAll })
            : _jsx(FunnalbackListingBlock, { initialBase: base, initialParams: params }));
    });
});
